import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ children }) => {
  // 2. Access the current location via hook
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);

    // Handle accessibility/focus blurring
    const { activeElement } = document;
    if (activeElement && typeof activeElement.blur === 'function') {
      activeElement.blur();
    }
  }, [pathname]); // Trigger whenever the path changes

  return children;
};

ScrollToTop.propTypes = {
  children: PropTypes.node.isRequired
};

export default ScrollToTop;
